import {post2, get2, get} from './base'

const POINT_BUY_LIST = '/vendor-api/pointManage/pointBuy/list'
const BONUS_PAY_LIST = '/vendor-api/pointManage/bonusPay/list'
const CONSUMER_INFO = '/vendor-api/pointManage/consumerInfo'
const DO_BONUS_PAY = '/vendor-api/pointManage/doBonusPay'
const WITHDRAW_LIST = '/vendor-api/pointManage/withdraw/list'
const RECORD_LIST = '/vendor-api/pointManage/record/list'
const COUPON_LIST = '/vendor-api/couponManage/coupon/list'
const COUPON_PENDING_LIST = '/vendor-api/couponManage/couponPendingList'
const CONFIRM_COUPON = '/vendor-api/couponManage/confirmCoupon'
const COUPON_USED_LIST = '/vendor-api/couponManage/couponUsedList'
const CREATE_COUPON = '/vendor-api/couponManage/create'
const UPDATE_COUPON = '/vendor-api/couponManage/update'
const EXCHANGE_RECORD = '/vendor-api/couponManage/exchangeRecord'
const CONSUMER_COUPON_INFO = '/vendor-api/couponManage/consumerCouponInfo'
const DO_COUPON_USE = '/vendor-api/couponManage/doCouponUse'

const CHANGE_VENDOR = '/vendor-api/changeVendor'
const CHANGE_PASSWORD = '/vendor-api/changePassword'

export default {
    pointBuyList( params) {
        return get2(POINT_BUY_LIST,params);
    },
    bonusPayList(params) {
        return get2(BONUS_PAY_LIST, params)
    },
    getConsumerInfo(params) {
        return get(CONSUMER_INFO, params);
    },
    doBonusPay(params) {
        return post2(DO_BONUS_PAY, params)
    },
    withdrawList(params) {
        return get2(WITHDRAW_LIST, params)
    },

    recordList(params) {
        return get2(RECORD_LIST, params)
    },
    couponList(params) {
        return get2(COUPON_LIST, params)
    },
    couponUsedList(params) {
        return get2(COUPON_USED_LIST, params)
    },

    createCoupon(params) {
        return post2(CREATE_COUPON, params)
    },

    updateCoupon(params) {
        return post2(UPDATE_COUPON, params)
    },

    exchangeRecord(params) {
        return get2(EXCHANGE_RECORD, params)
    },
    changeVendor(params) {
        return post2(CHANGE_VENDOR, params)
    },

    getConsumerCouponInfo(params) {
        return get2(CONSUMER_COUPON_INFO, params)
    },

    doCouponUse(params) {
        return post2(DO_COUPON_USE, params)
    },
    changePassword(params) {
        return post2(CHANGE_PASSWORD, params)
    },
    getCouponPendingList(params) {
        return get2(COUPON_PENDING_LIST, params)
    },
    confirmCoupon(params) {
        return post2(CONFIRM_COUPON, params)
    }
}
